<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11PjmvM/tc-custom/9781504086042.jpg?1720068855343" alt="This image is the cover for the book Eye of Strife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eye of Strife
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A group of strangers share tales of epic fantasy adventures as they confess what they know about a missing gem—or else risk the wrath of an angry god.</b></p><p> Legend has it that Quarn Axeswinger led a rebellion against the king but lost his sight in battle. The god Strife appeared and bestowed upon Quarn a jewel that gave him a mysterious new power. The man only had to promise to destroy any who defied him and spare those who submit. Quarn did . . . and went on to build a massive empire that continued to grow until after his death.  </p><p> However, this jewel, the Eye of Strife, disappeared a thousand years ago, and now Strife would like it back . . . </p><p> Someone has committed a terrible crime. To find out who, the high priest of Strife summons a group of strangers to the temple to share everything they know about the jewel. What follows is an evening of tales full of adventure, romance, and danger. Of course, not all the suspects are telling the truth, and at least one of them is guilty—and they will be punished. </p><p><b>Praise for Dave Duncan </b></p><p><b>“Dave Duncan knows how to spin a ripping good yarn.” —SFReviews.net</b></p><b>“Duncan is an exceedingly finished stylist and a master of world building and characterizations.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Duncan
      </h2>
      
      <p class="authorDescription body article">Dave Duncan (1933&ndash;2018) was born in Scotland, and received his diploma from Dundee High School and got his college education at the University of Saint Andrews. He moved to Canada in 1955, where he lived with his wife. Duncan spent thirty years as a petroleum geologist. He has had dozens of fantasy and science fiction novels published, among them <I>A Rose-Red City</I>, <I>Magic Casement</I>, and <I>The Reaver Road</I>, as well as a highly praised historical novel, <I>Daughter of Troy</I>, published, for commercial reasons, under the pseudonym Sarah B. Franklin. He also published the Longdirk series of novels, <I>Demon Sword</I>, <I>Demon Knight</I>, and <I>Demon Rider</I>, under the name Ken Hood.<BR /> &#160;<BR /> In the fall of 2007, Duncan&rsquo;s 2006 novel, <I>Children of Chaos</I>, published by Tor Books, was nominated for both the Prix Aurora Award and the Endeavour Award. In May 2013, Duncan, a 1989 founding member of SFCanada, was honored by election as a lifetime member by his fellow writers, editors, and academics. He passed away in 2018. Visit <a href="https://www.daveduncanauthor.com/">https://www.daveduncanauthor.com/ </a>for more information on the author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Five Rivers Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66c9ddde